import { Paper, Rating } from '@mui/material';
import { styled } from '@mui/system';

export const ReviewContainer = styled(Paper)(() => ({
  padding: '1.125rem 1.5rem',
  '.img-container': {
    height: '30px',
    'img': {
      objectFit: 'scale-down',
      height: '100%'
    }
  },
  margin: "auto",
  boxShadow: '0px 1px 5px 0px #0000001F',
  borderRadius: '4px',
  marginTop:'5px'
}));

export const RatingContainer = styled(Rating)(({ theme }) => ({
  color: 'rgba(0, 0, 0, 0.54)',
  '& .MuiRating-iconFilled': {
    color: theme.palette.primary.main,
  }
}));